$(document).ready(function() {
 	if( Modernizr.inputtypes.date) {
		$('#birthdate-mobile').show();
		$('#birthdate-fallback').remove();
	}
	$('#birthdate-fallback select').change(function(){
		var year = $('#birthdate-fallback select[name=Date_Year]').val();
		var month = $('#birthdate-fallback select[name=Date_Month]').val();
		var day = $('#birthdate-fallback select[name=Date_Day]').val();
		if(day < 10) day = '0'+day;
		
		var date = year+'-'+month+'-'+day; 
		$('#birthdate-picker').val(date);
	});
});


